import React, { useRef } from "react";
import { PurchaseSummaryColumns } from "../reports/itemExpiryReport/columns";
import { useSelector } from "react-redux";
import { selectWidth } from "../utility/Redux/profile";
import GeniusTableReports from "../utility/component/geniusComponents/geniusTableData";
import PrintWithFooter from "../utility/component/datagrid/geniusPrintDatagrid";
import { useReactToPrint } from "react-to-print";
import GeniusTableForReports from "../utility/component/datagrid/printReportWithFooter";

const ExpiryList = ({ expiryReportList, selectedTab, setSelectedTab }) => {
  const width = useSelector(selectWidth);
  const columns = PurchaseSummaryColumns(width);
  const printRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });
  return (
    <div className="h-full">
      <div className="flex">
        <div>
          <div
            style={{
              textDecoration: "none",
              color: "black",
              fontSize: "14px",
              border: `1px ${selectedTab === 0 ? "solid" : "dotted"} gray`,
              marginRight: 3,
            }}
            onClick={() => {
              setSelectedTab(0);
            }}
            className="py-2 px-6 rounded-sm  "
          >
            Purchase
          </div>
        </div>
        <div
          style={{
            textDecoration: "none",
            color: "black",
            fontSize: "14px",
            border: `1px ${selectedTab === 1 ? "solid" : "dotted"} ${
              expiryReportList[0] ? "red" : "gray"
            } `,
            marginRight: 3,
          }}
          onClick={() => {
            setSelectedTab(1);
          }}
          className="py-2 px-6 rounded-sm  "
        >
          Expiry Report
        </div>
      </div>
      {expiryReportList[0] && (
        <button
          onClick={handlePrint}
          className="flex items-center mt-2 rounded-sm shadow-sm  mr-2 "
          style={{
            backgroundColor: "#93c5fd",
            paddingLeft: 30,
            paddingRight: 30,
            paddingTop: 4,
            paddingBottom: 4,
            color: "black",
            height: "32px",
          }}
        >
          <i className="bi bi-printer pr-2"></i>
          <div className="flex items-center text-sm">Print</div>
        </button>
      )}

      <div
        style={{ height: `calc(100% - 100px)`, width: "100%", marginTop: 6 }}
        className=" mb-2 "
      >
        {expiryReportList[0] ? (
          <GeniusTableReports columns={columns} data={expiryReportList} />
        ) : (
          <div className="h-full flex justify-center items-center text-sm text-gray-400 border mt-3 rounded-sm">
            No Records Found
          </div>
        )}
      </div>

      <div>
        <div
          style={{
            display: "none",
          }}
        >
          <div ref={printRef}>
            <GeniusTableForReports
              title={"Item Expiry Report"}
              marginTop={"60px"}
              headerWidth={true}
              data={expiryReportList}
              columns={columns}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpiryList;
